import { ChartData, ChartOptions } from "chart.js";
import { FC, useMemo } from "react";
import { Chart } from "react-chartjs-2";

interface PieChartProps {
    data: ChartData<'doughnut'>,
    options?: ChartOptions<"doughnut"> & { maxLabels?: number }
}

function getLabelsOnlyTopX(num: number, data: any[], labels: any[]){
    let selectedLabels = []
    let helperData = [...data];
    helperData.sort( (a,b) => b-a);
    helperData = helperData.slice(0, num);
    let indexes = data.map( (value, index) => ({value,index}) ).filter(item => helperData.some(n1 => n1 == item.value))
    selectedLabels = labels.filter((value, index) => indexes.some( n => n.index == index))
    return selectedLabels.slice(0, num);
}

export const PieChart: FC<PieChartProps> = ({ data, options }) => {
    const showOnly = useMemo(() => getLabelsOnlyTopX(options.maxLabels, data.datasets[0]?.data || [], data.labels || []), [data, options])

    const opts: ChartOptions<"doughnut"> = {
        responsive: true,
        cutout: 80,
        maintainAspectRatio: false,
        backgroundColor: [
            "#C8FD01",
            "#66D9C7",
            "#0F4233",
            "#05CD99",
            "#85A801",
        ],
        plugins: {
            legend: {
                title: {
                    display: true,
                    padding: 5
                },
                labels: {
                    padding: 10,
                    boxHeight: 16,
                    boxWidth: 16,
                    usePointStyle: true,
                    pointStyle: 'circle',
                    color: '#5F666C',
                    filter(item) {
                        return options.maxLabels ? showOnly.indexOf(item.text) > -1 : true;
                    },
                },
                position: 'bottom',  
            },
        },
        ...options
    }
    return (
        <Chart 
            type={'doughnut'} 
            data={data} 
            options={opts}
        />
    )
}